"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOLogicV4__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AdminOnly",
        type: "error",
    },
    {
        inputs: [],
        name: "CanOnlyInitializeOnce",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidNounsAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidTimelockAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "MustProvideActions",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposalInfoArityMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposerAlreadyHasALiveProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "TooManyActions",
        type: "error",
    },
    {
        inputs: [],
        name: "UnsafeUint16Cast",
        type: "error",
    },
    {
        inputs: [],
        name: "VotesBelowProposalThreshold",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "numTokens",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "DAONounsSupplyIncreasedFromEscrow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "DAOWithdrawNounsFromEscrow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "oldErc20Tokens",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "newErc20tokens",
                type: "address[]",
            },
        ],
        name: "ERC20TokensToIncludeInForkSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "forkId",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "EscrowedToFork",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "forkId",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "forkTreasury",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "forkToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "forkEndTimestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokensInEscrow",
                type: "uint256",
            },
        ],
        name: "ExecuteFork",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldForkDAODeployer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newForkDAODeployer",
                type: "address",
            },
        ],
        name: "ForkDAODeployerSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldForkPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newForkPeriod",
                type: "uint256",
            },
        ],
        name: "ForkPeriodSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldForkThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newForkThreshold",
                type: "uint256",
            },
        ],
        name: "ForkThresholdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "forkId",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "JoinFork",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "oldLastMinuteWindowInBlocks",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "newLastMinuteWindowInBlocks",
                type: "uint32",
            },
        ],
        name: "LastMinuteWindowSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "oldMaxQuorumVotesBPS",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "MaxQuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "oldMinQuorumVotesBPS",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "MinQuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingVetoer",
                type: "address",
            },
        ],
        name: "NewPendingVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "oldObjectionPeriodDurationInBlocks",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "newObjectionPeriodDurationInBlocks",
                type: "uint32",
            },
        ],
        name: "ObjectionPeriodDurationSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCreatedOnTimelockV1",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "signers",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "updatePeriodEndBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "ProposalDescriptionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "objectionPeriodEndBlock",
                type: "uint256",
            },
        ],
        name: "ProposalObjectionPeriodSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "ProposalTransactionsUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "oldProposalUpdatablePeriodInBlocks",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "newProposalUpdatablePeriodInBlocks",
                type: "uint32",
            },
        ],
        name: "ProposalUpdatablePeriodSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "ProposalUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "oldQuorumCoefficient",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "QuorumCoefficientSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "refundAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "refundSent",
                type: "bool",
            },
        ],
        name: "RefundableVote",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "SignatureCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "timelock",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "timelockV1",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "TimelocksAndAdminSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "VoteCastWithClientId",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sent",
                type: "bool",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "forkId",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
        ],
        name: "WithdrawFromForkEscrow",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "adjustedTotalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "cancelSig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castRefundableVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "castRefundableVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castRefundableVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
            {
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "castRefundableVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "adjustedTotalSupply_",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOTypes.DynamicQuorumParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "dynamicQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "erc20TokensToIncludeInFork",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "escrowToFork",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "executeFork",
        outputs: [
            {
                internalType: "address",
                name: "forkTreasury",
                type: "address",
            },
            {
                internalType: "address",
                name: "forkToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "forkDAODeployer",
        outputs: [
            {
                internalType: "contract IForkDAODeployer",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "forkEndTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "forkEscrow",
        outputs: [
            {
                internalType: "contract INounsDAOForkEscrow",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "forkPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "forkThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "forkThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber_",
                type: "uint256",
            },
        ],
        name: "getDynamicQuorumParamsAt",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOTypes.DynamicQuorumParams",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NounsDAOTypes.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nouns_",
                type: "address",
            },
            {
                internalType: "address",
                name: "forkEscrow_",
                type: "address",
            },
            {
                internalType: "address",
                name: "forkDAODeployer_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "votingPeriod",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "votingDelay",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "proposalThresholdBPS",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "lastMinuteWindowInBlocks",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "objectionPeriodDurationInBlocks",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "proposalUpdatablePeriodInBlocks",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOTypes.NounsDAOParams",
                name: "daoParams_",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOTypes.DynamicQuorumParams",
                name: "dynamicQuorumParams_",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "proposalIds",
                type: "uint256[]",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "joinFork",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lastMinuteWindowInBlocks",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "numTokensInForkEscrow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "objectionPeriodDurationInBlocks",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingVetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "firstProposalId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastProposalId",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "proposalEligibilityQuorumBps",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "excludeCanceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "requireVotingEnded",
                type: "bool",
            },
            {
                internalType: "uint32[]",
                name: "votingClientIds",
                type: "uint32[]",
            },
        ],
        name: "proposalDataForRewards",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "objectionPeriodEndBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "creationTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "clientId",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "uint32",
                                name: "votes",
                                type: "uint32",
                            },
                            {
                                internalType: "uint32",
                                name: "txs",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct NounsDAOTypes.ClientVoteData[]",
                        name: "voteData",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct NounsDAOTypes.ProposalForRewards[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalUpdatablePeriodInBlocks",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "proposalThreshold",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quorumVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "vetoed",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "creationBlock",
                        type: "uint256",
                    },
                ],
                internalType: "struct NounsDAOTypes.ProposalCondensedV2",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "proposalsV3",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "proposalThreshold",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quorumVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "vetoed",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "creationBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "address[]",
                        name: "signers",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256",
                        name: "updatePeriodEndBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "objectionPeriodEndBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "executeOnTimelockV1",
                        type: "bool",
                    },
                ],
                internalType: "struct NounsDAOTypes.ProposalCondensedV3",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "sig",
                        type: "bytes",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "expirationTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct NounsDAOTypes.ProposerSignature[]",
                name: "proposerSignatures",
                type: "tuple[]",
            },
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "proposeBySigs",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "sig",
                        type: "bytes",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "expirationTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct NounsDAOTypes.ProposerSignature[]",
                name: "proposerSignatures",
                type: "tuple[]",
            },
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "proposeBySigs",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "proposeOnTimelockV1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "uint32",
                name: "clientId",
                type: "uint32",
            },
        ],
        name: "proposeOnTimelockV1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumParamsCheckpoints",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "fromBlock",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "minQuorumVotesBPS",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "maxQuorumVotesBPS",
                                type: "uint16",
                            },
                            {
                                internalType: "uint32",
                                name: "quorumCoefficient",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct NounsDAOTypes.DynamicQuorumParams",
                        name: "params",
                        type: "tuple",
                    },
                ],
                internalType: "struct NounsDAOTypes.DynamicQuorumParamsCheckpoint[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "quorumParamsCheckpoints",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "fromBlock",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "minQuorumVotesBPS",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "maxQuorumVotesBPS",
                                type: "uint16",
                            },
                            {
                                internalType: "uint32",
                                name: "quorumCoefficient",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct NounsDAOTypes.DynamicQuorumParams",
                        name: "params",
                        type: "tuple",
                    },
                ],
                internalType: "struct NounsDAOTypes.DynamicQuorumParamsCheckpoint",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NounsDAOTypes.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract INounsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelockV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "updateProposal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "sig",
                        type: "bytes",
                    },
                    {
                        internalType: "address",
                        name: "signer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "expirationTimestamp",
                        type: "uint256",
                    },
                ],
                internalType: "struct NounsDAOTypes.ProposerSignature[]",
                name: "proposerSignatures",
                type: "tuple[]",
            },
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "updateProposalBySigs",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "updateProposalDescription",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "updateMessage",
                type: "string",
            },
        ],
        name: "updateProposalTransactions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "voteSnapshotBlockSwitchProposalId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "withdrawDAONounsFromEscrowIncreasingTotalSupply",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
        ],
        name: "withdrawDAONounsFromEscrowToTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
        ],
        name: "withdrawFromForkEscrow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x608060405234801561000f575f80fd5b50615a39806200001e5f395ff3fe60806040526004361061043f575f3560e01c80637d17aa3a11610233578063c37522d41161012d578063da9427c4116100b5578063e48083fe11610079578063e48083fe14610b9a578063ea3ecd0f14610d1a578063f32293d214610d2e578063f851a44014610d42578063fe0d94c114610d5e57610446565b8063da9427c414610c42578063da95691a14610c61578063ddf0b00914610c80578063e23a9a5214610c9f578063e2742e1814610cee57610446565b8063d27dd112116100fc578063d27dd11214610bc1578063d33219b414610be0578063d8bff44014610bfd578063d93150be14610c1a578063da35c66414610c2e57610446565b8063c37522d414610b5a578063c3dd69eb14610b7b578063c82fbd0814610b9a578063cd0d9eac14610bad57610446565b806397242b8e116101bb578063aa0e23c71161017f578063aa0e23c714610acf578063abb308b214610afb578063b112626314610a7c578063b58131b014610b27578063b5cd5bfa14610b3b57610446565b806397242b8e14610a3e5780639a0dfb5314610a5d578063a64e024a14610a7c578063a67d063514610a91578063a9cf82f014610aae57610446565b806383cce0e11161020257806383cce0e1146109b657806384d1d199146109ca5780638f1314b6146109ee5780638f1447d914610a0257806390f8c2f414610a2157610446565b80637d17aa3a146109485780637f5ef445146109695780637fa230bd146109835780638136730f1461099757610446565b80633e2733341161034457806355ce73b1116102cc5780637217024c116102905780637217024c146108a657806377388b70146108c55780637757d18d146108f95780637b3c71d3146109165780637bdbe4d01461093557610446565b806355ce73b1146108095780635678138814610828578063590c1f161461084757806364c0599514610866578063705cb3351461088557610446565b806344fac8f61161031357806344fac8f61461076c57806347f4a0771461078b57806349e857ea146107b757806353349413146107d65780635408e7f2146107ea57610446565b80633e273334146106ee5780633e4f49e6146107025780633fde324d1461072e57806340e58ee51461074d57610446565b806328aa53e4116103c757806336a3b5781161039657806336a3b5781461066957806338b1c2f61461067d5780633932abb11461069c5780633b66c516146106b05780633bccf4fd146106cf57610446565b806328aa53e4146105cb5780632a4fa9fe146105ea5780632de45f1814610609578063328dd9821461063a57610446565b806316f1b8cf1161040e57806316f1b8cf1461052f57806317977c611461054e5780631d28dec7146105825780631e7b5d3a146105a3578063215809ca146105b757610446565b8063013cf08b146104a957806302a251a3146104de5780630f7b1f08146104fc57806314a67ea41461051b57610446565b3661044657005b5f36606061049d73__$2546bdef3c18d1713600cf5d21eb8a8445$__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__$da556bfbec7153838f28810e4476168f12$__906392be51d8906044016101e060405180830381865af4158015610e79573d5f803e3d5ffd5b505050506040513d601f19601f82011682018060405250810190610da59190614e7b565b5f610da58183612254565b5f610eb88787878787875f611921565b979650505050505050565b604051632cbebd3560e21b81525f60048201526024810182905273__$da556bfbec7153838f28810e4476168f12$__9063b2faf4d4906044015b5f6040518083038186803b158015610f13575f80fd5b505af4158015610f25573d5f803e3d5ffd5b5050505050565b6009546001600160a01b031615610f5657604051630205737f60e61b815260040160405180910390fd5b5f546001600160a01b03163314610f8057604051633057182d60e21b815260040160405180910390fd5b6001600160a01b038716610fa757604051637330d04160e11b815260040160405180910390fd5b6001600160a01b038616610fce5760405163d2ef0d7160e01b815260040160405180910390fd5b6040516303a8b66360e21b81528235600482015273__$2546bdef3c18d1713600cf5d21eb8a8445$__90630ea2d98c906024015f6040518083038186803b158015611017575f80fd5b505af4158015611029573d5f803e3d5ffd5b5050604051630efd8dad60e11b81526020850135600482015273__$2546bdef3c18d1713600cf5d21eb8a8445$__9250631dfb1b5a91506024015f6040518083038186803b158015611079575f80fd5b505af415801561108b573d5f803e3d5ffd5b5050604080516397d048e560e01b815290850135600482015273__$2546bdef3c18d1713600cf5d21eb8a8445$__92506397d048e591506024015f6040518083038186803b1580156110db575f80fd5b505af41580156110ed573d5f803e3d5ffd5b5050600980546001600160a01b03199081166001600160a01b038c811691909117909255600a805482168b8416179055601080546001600160601b0316600160601b8b851602179055601180548216898416179055600380549091169187169190911790555073__$2546bdef3c18d1713600cf5d21eb8a8445$__905063ec91deda61117c6020840184614f52565b61118c6040850160208601614f52565b61119c6060860160408701614f6b565b6040516001600160e01b031960e086901b16815261ffff938416600482015292909116602483015263ffffffff1660448201526064015f6040518083038186803b1580156111e8575f80fd5b505af41580156111fa573d5f803e3d5ffd5b5050505073__$2546bdef3c18d1713600cf5d21eb8a8445$__63e256077283606001602081019061122b9190614f6b565b6040516001600160e01b031960e084901b16815263ffffffff9190911660048201526024015f6040518083038186803b158015611266575f80fd5b505af4158015611278573d5f803e3d5ffd5b5050505073__$2546bdef3c18d1713600cf5d21eb8a8445$__63e5eb5abf8360800160208101906112a99190614f6b565b6040516001600160e01b031960e084901b16815263ffffffff9190911660048201526024015f6040518083038186803b1580156112e4575f80fd5b505af41580156112f6573d5f803e3d5ffd5b5050505073__$2546bdef3c18d1713600cf5d21eb8a8445$__6374b157b88360a00160208101906113279190614f6b565b6040516001600160e01b031960e084901b16815263ffffffff9190911660048201526024015b5f6040518083038186803b158015611363575f80fd5b505af4158015611375573d5f803e3d5ffd5b5050505050505050505050565b5f610eb860405180608001604052808981526020018881526020018781526020018681525084845f6122ac909392919063ffffffff16565b60608080806113c95f866123f6565b93509350935093509193509193565b6040516319244b1760e01b81525f600482018190529073__$33e7b0a3ca24f47dbd3e2894740686863c$__906319244b17906024015b602060405180830381865af4158015611429573d5f803e3d5ffd5b505050506040513d601f19601f8201168201806040525081019061144d9190614f84565b905090565b5f61148a604051806080016040528088815260200187815260200186815260200185815250835f8061267a909392919063ffffffff16565b9695505050505050565b5f610eb860405180608001604052808981526020018881526020018781526020018681525084845f61267a909392919063ffffffff16565b60405163f57e66d160e01b81525f60048201526024810186905260ff8086166044830152841660648201526084810183905260a4810182905273__$7631394927dd1ed2319cc9f46723260599$__9063f57e66d19060c4015b5f6040518083038186803b15801561153b575f80fd5b505af415801561154d573d5f803e3d5ffd5b505050505050505050565b5f61144d6115655f6126ef565b5f90612863565b6040516373d0ed2f60e01b81525f60048201819052602482018390529073__$da556bfbec7153838f28810e4476168f12$__906373d0ed2f90604401602060405180830381865af41580156115c3573d5f803e3d5ffd5b505050506040513d601f19601f82011682018060405250810190610da59190614f9b565b60405163b7aa3e5760e01b815273__$da556bfbec7153838f28810e4476168f12$__9063b7aa3e5790611622905f9086908690600401614fe1565b5f6040518083038186803b158015611638575f80fd5b505af415801561164a573d5f803e3d5ffd5b505050505050565b604051631e7296df60e11b81525f60048201526024810182905273__$da556bfbec7153838f28810e4476168f12$__90633ce52dbe90604401610efd565b604051637082ec2560e11b81525f600482018190526024820184905260ff83166044830152606482015273__$7631394927dd1ed2319cc9f46723260599$__9063e105d84a90608401611622565b604080516060810182525f8082526020820181905291810191909152610da55f8361287c565b6040516302bbd42360e11b815273__$33e7b0a3ca24f47dbd3e2894740686863c$__90630577a84690611622905f9086908690600401615033565b6040516383478b4360e01b815273__$da556bfbec7153838f28810e4476168f12$__906383478b4390611782905f908a908a908a908a908a908a9060040161504c565b5f6040518083038186803b158015611798575f80fd5b505af41580156117aa573d5f803e3d5ffd5b50505050505050505050565b60405163575535f360e11b815273__$33e7b0a3ca24f47dbd3e2894740686863c$__9063aeaa6be6906117f3905f908790879087906004016150c6565b5f6040518083038186803b158015611809575f80fd5b505af415801561181b573d5f803e3d5ffd5b50505050505050565b60405163555d910560e11b81525f60048201526024810183905260ff8216604482015273__$7631394927dd1ed2319cc9f46723260599$__9063aabb220a90606401611622565b604051633d43469f60e11b815273__$33e7b0a3ca24f47dbd3e2894740686863c$__90637a868d3e90611782905f908a908a908a908a908a908a906004016150f8565b60405163286f3e7b60e11b815273__$7631394927dd1ed2319cc9f46723260599$__906350de7cf6906118ef905f9088908890889088908590600401615139565b5f6040518083038186803b158015611905575f80fd5b505af4158015611917573d5f803e3d5ffd5b5050505050505050565b60408051608081018252878152602081018790528082018690526060810185905290516320660f5360e01b81525f9173__$da556bfbec7153838f28810e4476168f12$__916320660f53916119809185918d91899089906004016152cb565b602060405180830381865af415801561199b573d5f803e3d5ffd5b505050506040513d601f19601f820116820180604052508101906119bf9190614f84565b98975050505050505050565b6040516338251d8960e11b81525f6004820181905290819073__$33e7b0a3ca24f47dbd3e2894740686863c$__9063704a3b12906024016040805180830381865af4158015611a1c573d5f803e3d5ffd5b505050506040513d601f19601f82011682018060405250810190611a409190615322565b915091509091565b60405163b73a99c760e01b815273__$7631394927dd1ed2319cc9f46723260599$__9063b73a99c7906118ef905f90889088908890889060040161534f565b5f61144d611a945f6126ef565b5f90612b81565b60405163286f3e7b60e11b815273__$7631394927dd1ed2319cc9f46723260599$__906350de7cf690611525905f9089908990899089908990600401615139565b5f61144d5f6126ef565b604051637082ec2560e11b81525f60048201526024810184905260ff8316604482015263ffffffff8216606482015273__$7631394927dd1ed2319cc9f46723260599$__9063e105d84a906084016117f3565b604080516080810182528781526020810187905280820186905260608101859052905163f9df1e1960e01b815273__$da556bfbec7153838f28810e4476168f12$__9163f9df1e1991611b98915f918d918d9189908990600401615377565b5f6040518083038186803b158015611bae575f80fd5b505af4158015611bc0573d5f803e3d5ffd5b505050505050505050505050565b60405163bb29607560e01b81525f9073__$9c0931d68a127b468eb017c79ed5096eb4$__9063bb29607590611c0b908790879087906004016153dc565b602060405180830381865af4158015611c26573d5f803e3d5ffd5b505050506040513d601f19601f82011682018060405250810190611c4a9190614f84565b90505b9392505050565b60605f600d01805480602002602001604051908101604052809291908181526020015f905b82821015611ced575f84815260209081902060408051808201825260028602909201805463ffffffff9081168452825160608101845260019283015461ffff80821683526201000082041682880152600160201b900490911692810192909252828401919091529083529092019101611c79565b50505050905090565b60606119bf5f89898989898989612b9d565b611d3a6040805180820182525f8082528251606081018452818152602081810183905293810191909152909182015290565b600d805483908110611d4e57611d4e615419565b5f9182526020918290206040805180820182526002909302909101805463ffffffff9081168452825160608101845260019092015461ffff80821684526201000082041683870152600160201b900416918101919091529181019190915292915050565b5f61144d611dbe611adc565b5f90612f7d565b604051633d99f84560e21b815273__$33e7b0a3ca24f47dbd3e2894740686863c$__9063f667e11490611782905f908a908a908a908a908a908a906004016150f8565b60605f601201805480602002602001604051908101604052809291908181526020018280548015611e6057602002820191905f5260205f20905b81546001600160a01b03168152600190910190602001808311611e42575b5050505050905090565b6040516316147f8760e31b815273__$da556bfbec7153838f28810e4476168f12$__9063b0a3fc3890611525905f908990899089908990899060040161542d565b6040516309ea0cfb60e11b81525f600482018190529073__$33e7b0a3ca24f47dbd3e2894740686863c$__906313d419f69060240161140e565b604051636055f93560e01b815273__$33e7b0a3ca24f47dbd3e2894740686863c$__90636055f93590611622905f9086908690600401615033565b604051637b55bff360e01b815273__$da556bfbec7153838f28810e4476168f12$__90637b55bff39061134d905f908b908b908b908b908b908b908b9060040161545f565b5f61148a86868686865f611382565b60405163179aac6b60e21b81525f60048201526024810182905273__$da556bfbec7153838f28810e4476168f12$__90635e6ab1ac90604401610efd565b60408051606080820183525f8083526020808401829052838501829052845180840186528281528082018390528501829052868252600b81528482206001600160a01b0387168352600f01815290849020845192830185525460ff80821615158452610100820416918301919091526201000090046001600160601b03169281019290925290610da2565b6120d16040518061026001604052805f81526020015f6001600160a01b031681526020015f81526020015f81526020015f81526020015f81526020015f81526020015f81526020015f81526020015f81526020015f151581526020015f151581526020015f151581526020015f81526020015f8152602001606081526020015f81526020015f81526020015f151581525090565b60405163ddb6398360e01b81525f60048201526024810183905273__$da556bfbec7153838f28810e4476168f12$__9063ddb63983906044015f60405180830381865af4158015612124573d5f803e3d5ffd5b505050506040513d5f823e601f3d908101601f19168201604052610da59190810190615556565b60405163370d357760e01b81525f60048201526024810182905273__$da556bfbec7153838f28810e4476168f12$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class NounsDAOLogicV4__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, NounsDAOLogicV4__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$2546bdef3c18d1713600cf5d21eb8a8445\\$__", "g"), linkLibraryAddresses["contracts/governance/NounsDAOAdmin.sol:NounsDAOAdmin"]
            .replace(/^0x/, "")
            .toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$da556bfbec7153838f28810e4476168f12\\$__", "g"), linkLibraryAddresses["contracts/governance/NounsDAOProposals.sol:NounsDAOProposals"]
            .replace(/^0x/, "")
            .toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$33e7b0a3ca24f47dbd3e2894740686863c\\$__", "g"), linkLibraryAddresses["contracts/governance/fork/NounsDAOFork.sol:NounsDAOFork"]
            .replace(/^0x/, "")
            .toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$7631394927dd1ed2319cc9f46723260599\\$__", "g"), linkLibraryAddresses["contracts/governance/NounsDAOVotes.sol:NounsDAOVotes"]
            .replace(/^0x/, "")
            .toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$9c0931d68a127b468eb017c79ed5096eb4\\$__", "g"), linkLibraryAddresses["contracts/governance/NounsDAODynamicQuorum.sol:NounsDAODynamicQuorum"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOLogicV4__factory = NounsDAOLogicV4__factory;
NounsDAOLogicV4__factory.bytecode = _bytecode;
NounsDAOLogicV4__factory.abi = _abi;
